import ApiService from '@/services/api.service.js';
import store from '@/store/index.js';

export default function useAccountRepository() {
  const appsettings = store.state.appSettings;
  const isNotEmpty = (value) => value !== undefined && value !== null && value !== '';

  const load = (loadOptions, clientId) => {
    let params = '?';

    [
      'filter',
      'group',
      'groupSummary',
      'parentIds',
      'requireGroupCount',
      'requireTotalCount',
      'searchExpr',
      'searchOperation',
      'searchValue',
      'select',
      'sort',
      'skip',
      'take',
      'totalSummary',
      'userData',
    ].forEach((i) => {
      if (i in loadOptions && isNotEmpty(loadOptions[i])) {
        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
      }
    });
    params = params.slice(0, -1);

    return ApiService
      .get(`${appsettings.ADMINISTRATION_API}/api/v1/accountmapping/clients/${clientId}/overview${params}`);
  };

  const saveAccountMapping = (clientId, accountId, productIdList) => ApiService
    .put(`${appsettings.ADMINISTRATION_API}/api/v1/accountmapping/clients/${clientId}/mapproducts/${accountId}`, { list: productIdList });

  return {
    load,
    saveAccountMapping,
  };
}
